(function (w) {
	'use strict';

	function MxTreeview() {
		var directive = new mx.components.FormControlBase(MxTreeviewCtrl, 'mx-treeview/mx-treeview.html');
		angular.extend(directive.bindToController, {
			items: '<',
			selectedItem: '=?',
			templateId: '@',
			parentControllerAs: '@',
			parentField: '@',
			idField: '@',
			orderBy: '@',
			expandByButton: '@',
			expandByDefault: '@',
			autoSelectFirst: '@',
			showAsList: '@',
			parent: '<',
			showAdd: '@',
			showEdit: '@',
			showDelete: '@',
			onAdd: '&',
			onDelete: '&',
			onEdit: '&',
		});
		directive.controllerAs = '__$vm';
		return directive;
	}

	MxTreeviewCtrl.$inject = ['$scope', '$timeout', 'mx.internationalization'];

	function MxTreeviewCtrl($scope, $timeout, i18n) {
		var vm = this;
		var expandByButton;
		var items;
		var initialized;
		var watchers = [];
		vm.i18n = i18n.get('components.mx-treeview');

		vm.$onInit = function () {
			vm._showAdd = vm.showAdd === 'true';
			vm._showDelete = vm.showDelete === 'true';
			vm._showEdit = vm.showEdit === 'true';
			vm._showAsList = vm.showAsList === 'true';
			vm._expandByDefault = vm.expandByDefault === 'true';

			vm._onAdd = vm.onAdd() || function () {};
			vm._onDelete = vm.onDelete() || function () {};
			vm._onEdit = vm.onEdit() || function () {};

			vm.parentField = vm.parentField || 'Parent';
			vm.idField = vm.idField || 'Id';
			expandByButton = vm.expandByButton !== 'false';
			items = vm.items;

			mx.components.FormControlControllerBase.call(vm, $timeout);
			initScope();

			vm.getStatus = function (item) {
				return vm.itemsStatus[item[vm.idField]];
			};

			vm.expandButtonClick = function ($event, item) {
				$event.stopPropagation();
				if (item) {
					var status = vm.getStatus(item);
					status.expanded = !status.expanded;
				}
			};
			var selectedItem = vm.selectedItem;

			vm.itemClick = function ($event, item) {
				if ($event) {
					$event.stopPropagation();
				}

				if (vm._expandByDefault) {
					return;
				}

				_.forIn(vm.itemsStatus, function (value) {
					value.selected = false;
				});

				if (item) {
					var status = vm.getStatus(item);
					if (status) {
						if (!status.showExpandButton && status.hasChildren && $event) {
							status.expanded = !status.expanded;
						}

						status.selected = true;
						selectedItem = item;
					} else if (!$event) {
						let currentItem = item;

						let parent = currentItem[vm.parentField];
						while (parent) {
							currentItem = items.filter(getParent(parent))[0];
							status = vm.getStatus(currentItem);
							if (status) {
								status.expanded = true;
							}
							parent = currentItem[vm.parentField];
						}
					}
				}
			};

			function getParent(parent) {
				return function (x) {
					return x[vm.idField] === parent;
				};
			}

			function initTopLevelItems() {
				vm.itemsStatus = {};
				vm.topLevelItems = items.filter(function (item) {
					return vm._showAsList || (!vm.parent && !item[vm.parentField]) || (vm.parent && vm.parent[vm.idField] === item[vm.parentField]);
				});

				if (vm.orderBy) {
					vm.topLevelItems = vm.topLevelItems.sort(function (a, b) {
						var aValue = a[vm.orderBy];
						if (typeof aValue === 'number') {
							return aValue - b[vm.orderBy];
						} else if (typeof aValue === 'string') {
							return aValue.localeCompare(b[vm.orderBy]);
						}
						return 0;
					});
				}

				if (!initialized && vm.autoSelectFirst === 'true') {
					vm.selectedItem = vm.topLevelItems[0];
				}

				vm.topLevelItems.forEach(function (item) {
					var hasChildren = items.some(function (node) {
						return item[vm.idField] === node[vm.parentField];
					});

					vm.itemsStatus[item[vm.idField]] = {
						hasChildren: hasChildren,
						showExpandButton: hasChildren && expandByButton && !vm._showAsList,
						expanded: vm._expandByDefault,
						selected: false,
					};
				});
				vm.itemClick(null, selectedItem);
				if (!initialized) {
					addWatchers();
					initialized = true;
				}
			}

			function addWatchers() {
				watchers.push(
					$scope.$watch('__$vm.showAsList', function (updata) {
						vm._showAsList = updata === 'true';
						initTopLevelItems();
					})
				);

				if (vm.orderBy) {
					watchers.push(
						$scope.$watch(
							'__$vm.selectedItem',
							function (newVal, oldVal) {
								if (
									newVal &&
									oldVal &&
									newVal[vm.orderBy] !== oldVal[vm.orderBy] &&
									items.some(function (t) {
										return t[vm.idField] === newVal[vm.idField];
									})
								) {
									initTopLevelItems();
								}
							},
							true
						)
					);
				}

				$scope.$on('$destroy', function () {
					watchers.forEach(function (w) {
						w();
					});
					watchers = [];
				});
			}

			Object.defineProperty(vm, 'selectedItem', {
				get: function () {
					return selectedItem;
				},
				set: function (value) {
					selectedItem = value;
					vm.itemClick(null, selectedItem);
				},
			});

			Object.defineProperty(vm, 'items', {
				get: function () {
					return items;
				},
				set: function (value) {
					items = value;
					initTopLevelItems();
					vm.itemClick(null, selectedItem);
				},
			});

			vm.add = function ($event, item) {
				$event.stopPropagation();
				vm._onAdd(item);
			};

			vm.edit = function ($event, item) {
				$event.stopPropagation();
				vm._onEdit(item);
			};

			vm.delete = function ($event, item) {
				$event.stopPropagation();
				vm._onDelete(item);
			};
			initTopLevelItems();
		};

		function initScope() {
			if (vm.parentControllerAs) {
				$scope[vm.parentControllerAs] = $scope.$parent[vm.parentControllerAs];
			} else {
				$scope.dataModel = $scope.$parent;
			}
		}

		return vm;
	}

	function deleteFunc(options, item) {
		const itemsForDelete = [item || options.selectedItem];
		let currentItems = [item || options.selectedItem];
		do {
			currentItems = options.items.filter(getChildren(options, currentItems));
			Array.prototype.push.apply(itemsForDelete, currentItems);
		} while (currentItems.length);

		options.items = options.items.filter(function (item) {
			return !itemsForDelete.some(function (t) {
				return t[options.idField] === item[options.idField];
			});
		});

		if (!item || options.selectedItem[options.idField] === item[options.idField]) {
			options.selectedItem = undefined;
		}
	}

	function getChildren(options, items) {
		return function (item) {
			return items.some(function (t) {
				return t[options.idField] === item[options.parentField];
			});
		};
	}

	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.Treeview = MxTreeview;
	w.mx.components.Treeview.DeleteItem = deleteFunc;
	angular.module('mx.components').directive('mxTreeview', MxTreeview);
})(window);
